import { useQuery } from "@tanstack/react-query";
import api from "api";

const timezonesKey = "timezones";

const timezonesKeys = {
  getTimezonesKey: () => [timezonesKey],
};

const useTimezonesQuery = (options = {}) => {
  return useQuery(timezonesKeys.getTimezonesKey(), async () => api.get("timezones"), {
    staleTime: Infinity,
    cacheTime: Infinity,
    ...options,
  });
};

export { useTimezonesQuery };
